import React from 'react';
import { DateTime } from 'luxon';
import SpotlightHeader from '../../Common/Header';
import PageIndicator from '../../Common/PageIndicator';
import BottomBar from '../../../components/BottomBar';
import { usePager } from '../../../helpers/pagination';
import { Textfit } from 'react-textfit';
import './HuddleNotes.scss';
const HuddleNotes = props => {
  var _metadata$boh_huddle_, _boh_huddle_notes$not;
  const {
    bohStyle,
    text,
    metadata,
    duration,
    playing
  } = props;
  const boh_huddle_notes = (_metadata$boh_huddle_ = metadata.boh_huddle_notes) !== null && _metadata$boh_huddle_ !== void 0 ? _metadata$boh_huddle_ : {};
  const date = boh_huddle_notes.date ? DateTime.fromISO(boh_huddle_notes.date).toFormat('MM-dd-yyyy') : 'N/A';
  const notes = ((_boh_huddle_notes$not = boh_huddle_notes.notes) !== null && _boh_huddle_notes$not !== void 0 ? _boh_huddle_notes$not : []).filter(note => !!note);
  const hide_poweredbyshift = metadata.hide_poweredbyshift;
  const {
    accent_color,
    text_accent_color,
    containerStyle
  } = bohStyle;
  const [page, pageIdx, pages] = usePager(notes, duration * 1000, playing, 1);
  return /*#__PURE__*/React.createElement("div", {
    className: "notes-container",
    style: containerStyle
  }, /*#__PURE__*/React.createElement(SpotlightHeader, {
    text: text,
    metadata: metadata
  }), /*#__PURE__*/React.createElement("div", {
    className: "notes-body-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "notes-date"
  }, date), /*#__PURE__*/React.createElement("div", {
    className: "notes-text"
  }, page.map((note, idx) => /*#__PURE__*/React.createElement(Textfit, {
    className: "tex-fit",
    max: 400,
    key: idx
  }, note)))), /*#__PURE__*/React.createElement("div", {
    className: "notes-bottom-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "page-indicator"
  }, pages.length > 1 && /*#__PURE__*/React.createElement(PageIndicator, {
    pages: pages,
    current: pageIdx,
    selectedColor: accent_color
  }))), /*#__PURE__*/React.createElement(BottomBar, {
    accent_color: accent_color,
    accent_text_color: text_accent_color,
    hide_poweredbyshift: hide_poweredbyshift
  }));
};
export default HuddleNotes;